import '@fontsource/inter';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import createTypography from '@material-ui/core/styles/createTypography';
import { palette } from './palette';
import { baseFontSize, pxToRem } from './utils';
/**
 * Custom typography configuration for AgentNet. To be extended by each brand where needed.
 *
 * @returns {Typography}
 */
export const typography = createTypography(palette, {
    fontFamily: ['Inter', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    fontSize: baseFontSize,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    htmlFontSize: baseFontSize,
    allVariants: {
        fontFamily: ['Inter', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    },
    body1: {
        fontSize: pxToRem(14),
        lineHeight: pxToRem(21),
    },
    body2: {
        fontSize: pxToRem(12),
        lineHeight: pxToRem(18),
    },
    caption: {
        display: 'block',
        fontSize: pxToRem(12),
        letterSpacing: pxToRem(0.4),
    },
    h1: {
        fontSize: pxToRem(23),
        fontWeight: 500,
        lineHeight: pxToRem(34),
    },
    h2: {
        fontSize: pxToRem(20),
        fontWeight: 500,
        lineHeight: pxToRem(30),
    },
    h3: {
        fontSize: pxToRem(18),
        fontWeight: 500,
        lineHeight: pxToRem(27),
    },
    h4: {
        fontSize: pxToRem(16),
        fontWeight: 500,
        lineHeight: pxToRem(24),
        margin: '0 0 8px',
    },
    h5: {
        fontSize: pxToRem(14),
        fontWeight: 500,
        lineHeight: pxToRem(21),
    },
    h6: {
        fontSize: pxToRem(12),
        fontWeight: 500,
        lineHeight: pxToRem(18),
    },
    overline: {
        color: palette.text.primary,
        display: 'block',
        fontSize: pxToRem(12),
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(32),
        textTransform: 'uppercase',
    },
    subtitle1: {
        color: palette.text.primary,
        fontFamily: 'Inter',
        fontSize: pxToRem(25),
        fontStyle: 'normal',
        fontWeight: 400,
        letterSpacing: pxToRem(0.15),
        lineHeight: '175%',
    },
    subtitle2: {
        color: palette.text.primary,
        fontFamily: 'Inter',
        fontSize: pxToRem(22),
        fontStyle: 'normal',
        fontWeight: 500,
        letterSpacing: pxToRem(0.1),
        lineHeight: '157%',
    },
});
